const isFirefox = navigator.userAgent.includes('Firefox');
const isMobile = window.matchMedia('(max-width: 991px)').matches;

if (!isFirefox && !isMobile) document.querySelectorAll('scroll-video-bg').forEach((el) => {
  const src = el.dataset.src;
  const section = el.closest('section');
  if (!src || !section) return;

  const video = document.createElement('video');
  video.src = src;
  video.muted = true;
  video.playsInline = true;
  video.preload = 'auto';
  el.appendChild(video);

  let top = 0;
  let height = 0;
  let started = false;

  function recalc() {
    top = section.getBoundingClientRect().top + window.scrollY;
    height = section.offsetHeight;
  }

  function update() {
    if (!video.duration) return;
    const progress = (window.scrollY + window.innerHeight - top) / (window.innerHeight + height);
    video.currentTime = Math.max(0, Math.min(1, progress)) * video.duration;
  }

  function start() {
    if (started) return;
    started = true;
    video.pause();
    recalc();
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', recalc, { passive: true });
  }

  function tryStart() {
    if (video.readyState >= 1) {
      start();
    } else {
      video.addEventListener('loadedmetadata', start, { once: true });
      video.load();
    }
  }

  window.addEventListener('load', tryStart, { once: true });
});
